import {ResultsBackgroundGalaxyInteractivityComponent} from '../../ui/pages/ClickerGamePage/clicker-game/game-objects/BackgroundGalaxy/components/ResultsBackgroundGalaxyInteractivityComponent';
import {ResultsStartUpScript} from '../../ui/pages/ClickerGamePage/clicker-game/scripts/ResultsStartUpScript';
import {CLICKER_GAME_TOKENS} from './di.clicker-game.tokens';
import {GCS_TOKENS} from './di.gcs.tokens';

import {Container, injected} from 'brandi';

import {ClickerAudioPlayer} from '@/ui/pages/ClickerGamePage/clicker-game/ClickerAudioPlayer';
import {ClickerGameAssetsLoader} from '@/ui/pages/ClickerGamePage/clicker-game/ClickerGameAssetsLoader';
import {ClickerGameEvents} from '@/ui/pages/ClickerGamePage/clicker-game/ClickerGameEvents';
import {ClickerGameResultsScene} from '@/ui/pages/ClickerGamePage/clicker-game/ClickerGameResultsScene';
import {ClickerGameScene} from '@/ui/pages/ClickerGamePage/clicker-game/ClickerGameScene';
import {ClickerGameSpawner} from '@/ui/pages/ClickerGamePage/clicker-game/ClickerGameSpawner';
import {EmitterPoolComponent} from '@/ui/pages/ClickerGamePage/clicker-game/components/EmitterPoolComponent';
import {HeartsEmitterComponent} from '@/ui/pages/ClickerGamePage/clicker-game/components/HeartsEmitterComponent/HeartsEmitterComponent';
import {WaveEmitterComponent} from '@/ui/pages/ClickerGamePage/clicker-game/components/WaveEmitterComponent/WaveEmitterComponent';
import {Asteroid} from '@/ui/pages/ClickerGamePage/clicker-game/game-objects/Asteroid/Asteroid';
import {AsteroidDataComponent} from '@/ui/pages/ClickerGamePage/clicker-game/game-objects/Asteroid/AsteroidDataComponent';
import {AsteroidInteractiveComponent} from '@/ui/pages/ClickerGamePage/clicker-game/game-objects/Asteroid/AsteroidInteractiveComponent';
import {AsteroidViewComponent} from '@/ui/pages/ClickerGamePage/clicker-game/game-objects/Asteroid/AsteroidViewComponent';
import {BackgroundGalaxy} from '@/ui/pages/ClickerGamePage/clicker-game/game-objects/BackgroundGalaxy/BackgroundGalaxy';
import {ResultsBackgroundGalaxy} from '@/ui/pages/ClickerGamePage/clicker-game/game-objects/BackgroundGalaxy/ResultsBackgroundGalaxy';
import {BackgroundGalaxyDataComponent} from '@/ui/pages/ClickerGamePage/clicker-game/game-objects/BackgroundGalaxy/components/BackgroundGalaxyDataComponent';
import {BackgroundGalaxyInteractivityComponent} from '@/ui/pages/ClickerGamePage/clicker-game/game-objects/BackgroundGalaxy/components/BackgroundGalaxyInteractivityComponent';
import {BackgroundGalaxyStarsComponent} from '@/ui/pages/ClickerGamePage/clicker-game/game-objects/BackgroundGalaxy/components/BackgroundGalaxyStarsComponent';
import {BackgroundGalaxyViewComponent} from '@/ui/pages/ClickerGamePage/clicker-game/game-objects/BackgroundGalaxy/components/BackgroundGalaxyViewComponent';
import {ResultsBackgroundGalaxyDataComponent} from '@/ui/pages/ClickerGamePage/clicker-game/game-objects/BackgroundGalaxy/components/ResultsBackgroundGalaxyDataComponent';
import {BonusDestroyEffect} from '@/ui/pages/ClickerGamePage/clicker-game/game-objects/BonusDestroyEffect/BonusDestroyEffect';
import {BonusDestroyEffectEmitterComponent} from '@/ui/pages/ClickerGamePage/clicker-game/game-objects/BonusDestroyEffect/BonusDestroyEffectEmitterComponent';
import {Cometa} from '@/ui/pages/ClickerGamePage/clicker-game/game-objects/Cometa/Cometa';
import {CometaDataComponent} from '@/ui/pages/ClickerGamePage/clicker-game/game-objects/Cometa/CometaDataComponent';
import {CometaInteractiveComponent} from '@/ui/pages/ClickerGamePage/clicker-game/game-objects/Cometa/CometaInteractiveComponent';
import {CometaViewComponent} from '@/ui/pages/ClickerGamePage/clicker-game/game-objects/Cometa/CometaViewComponent';
import {EmittersContainer} from '@/ui/pages/ClickerGamePage/clicker-game/game-objects/EmittersContainer/EmittersContainer';
import {EmittersContainerViewComponent} from '@/ui/pages/ClickerGamePage/clicker-game/game-objects/EmittersContainer/EmittersContainerViewComponent';
import {PointsEmitter} from '@/ui/pages/ClickerGamePage/clicker-game/game-objects/PointsEmitterPool/PointsEmitter';
import {PointsEmitterPoolComponent} from '@/ui/pages/ClickerGamePage/clicker-game/game-objects/PointsEmitterPool/PointsEmitterPoolComponent';
import {ResultsSpaceship} from '@/ui/pages/ClickerGamePage/clicker-game/game-objects/Spaceship/ResultsSpaceship';
import {Spaceship} from '@/ui/pages/ClickerGamePage/clicker-game/game-objects/Spaceship/Spaceship';
import {ResultsSpaceshipAnimationManagerComponent} from '@/ui/pages/ClickerGamePage/clicker-game/game-objects/Spaceship/components/ResultsSpaceshipAnimationManagerComponent';
import {ResultsSpaceshipDataComponent} from '@/ui/pages/ClickerGamePage/clicker-game/game-objects/Spaceship/components/ResultsSpaceshipDataComponent';
import {ResultsSpaceshipInteractivityComponent} from '@/ui/pages/ClickerGamePage/clicker-game/game-objects/Spaceship/components/ResultsSpaceshipInteractivityComponent';
import {SpaceshipAnimationComponent} from '@/ui/pages/ClickerGamePage/clicker-game/game-objects/Spaceship/components/SpaceshipAnimationComponent';
import {SpaceshipAnimationManagerComponent} from '@/ui/pages/ClickerGamePage/clicker-game/game-objects/Spaceship/components/SpaceshipAnimationManagerComponent';
import {SpaceshipDataComponent} from '@/ui/pages/ClickerGamePage/clicker-game/game-objects/Spaceship/components/SpaceshipDataComponent';
import {SpaceshipInteractivityComponent} from '@/ui/pages/ClickerGamePage/clicker-game/game-objects/Spaceship/components/SpaceshipInteractivityComponent';
import {SpaceshipMessageComponent} from '@/ui/pages/ClickerGamePage/clicker-game/game-objects/Spaceship/components/SpaceshipMessageComponent';
import {SpaceshipViewComponent} from '@/ui/pages/ClickerGamePage/clicker-game/game-objects/Spaceship/components/SpaceshipViewComponent';
import {BonusesObserverScript} from '@/ui/pages/ClickerGamePage/clicker-game/scripts/BonusesObserverScript';
import {OnboardingScript} from '@/ui/pages/ClickerGamePage/clicker-game/scripts/OnboardingScript';
import {SpawnBonusesScript} from '@/ui/pages/ClickerGamePage/clicker-game/scripts/SpawnBonusesScript';
import {StartUpScript} from '@/ui/pages/ClickerGamePage/clicker-game/scripts/StartUpScript';
import {VisibilityChangeScript} from '@/ui/pages/ClickerGamePage/clicker-game/scripts/VisibilityChangeScript';

export function initClickerGameDeps(container: Container): void {
  container.bind(CLICKER_GAME_TOKENS.clickerGameAssetsLoader).toInstance(ClickerGameAssetsLoader).inSingletonScope();

  container.bind(CLICKER_GAME_TOKENS.clickerGameScene).toInstance(ClickerGameScene).inSingletonScope();
  container.bind(CLICKER_GAME_TOKENS.clickerGameResultsScene).toInstance(ClickerGameResultsScene).inSingletonScope();

  container.bind(CLICKER_GAME_TOKENS.clickerGameSpawner).toInstance(ClickerGameSpawner).inTransientScope();

  container.bind(CLICKER_GAME_TOKENS.clickerGameSpaceship).toFactory(Spaceship);
  container.bind(CLICKER_GAME_TOKENS.clickerGameResultsSpaceship).toFactory(ResultsSpaceship);

  container
    .bind(CLICKER_GAME_TOKENS.clickerGameSpaceshipViewComponent)
    .toInstance(SpaceshipViewComponent)
    .inTransientScope();

  container
    .bind(CLICKER_GAME_TOKENS.clickerSpaceshipMessageComponent)
    .toInstance(SpaceshipMessageComponent)
    .inTransientScope();

  container
    .bind(CLICKER_GAME_TOKENS.clickerGameSpaceshipInteractivityComponent)
    .toInstance(SpaceshipInteractivityComponent)
    .inTransientScope();
  container
    .bind(CLICKER_GAME_TOKENS.clickerGameResultsSpaceshipInteractivityComponent)
    .toInstance(ResultsSpaceshipInteractivityComponent)
    .inTransientScope();

  container
    .bind(CLICKER_GAME_TOKENS.clickerGameResultsBackgroundInteractivityComponent)
    .toInstance(ResultsBackgroundGalaxyInteractivityComponent)
    .inTransientScope();

  container
    .bind(CLICKER_GAME_TOKENS.clickerGameHeartsEmitterComponent)
    .toInstance(HeartsEmitterComponent)
    .inTransientScope();

  container
    .bind(CLICKER_GAME_TOKENS.clickerGameWaveEmitterComponent)
    .toInstance(WaveEmitterComponent)
    .inTransientScope();

  container
    .bind(CLICKER_GAME_TOKENS.clickerGameSpaceshipAnimationComponent)
    .toInstance(SpaceshipAnimationComponent)
    .inTransientScope();

  container
    .bind(CLICKER_GAME_TOKENS.clickerGameSpaceshipDataComponent)
    .toInstance(SpaceshipDataComponent)
    .inTransientScope();

  container
    .bind(CLICKER_GAME_TOKENS.clickerGameResultsSpaceshipDataComponent)
    .toInstance(ResultsSpaceshipDataComponent)
    .inTransientScope();

  container
    .bind(CLICKER_GAME_TOKENS.clickerGameSpaceshipAnimationManagerComponent)
    .toInstance(SpaceshipAnimationManagerComponent)
    .inTransientScope();

  container
    .bind(CLICKER_GAME_TOKENS.clickerGameResultsSpaceshipAnimationManagerComponent)
    .toInstance(ResultsSpaceshipAnimationManagerComponent)
    .inTransientScope();

  container.bind(CLICKER_GAME_TOKENS.clickerGameBackgroundGalaxy).toFactory(BackgroundGalaxy);
  container.bind(CLICKER_GAME_TOKENS.clickerGameResultsBackgroundGalaxy).toFactory(ResultsBackgroundGalaxy);

  container
    .bind(CLICKER_GAME_TOKENS.clickerGameBackgroundGalaxyDataComponent)
    .toInstance(BackgroundGalaxyDataComponent)
    .inTransientScope();
  container
    .bind(CLICKER_GAME_TOKENS.clickerGameResultsBackgroundGalaxyDataComponent)
    .toInstance(ResultsBackgroundGalaxyDataComponent)
    .inTransientScope();

  container
    .bind(CLICKER_GAME_TOKENS.clickerGameEmitterPoolComponent)
    .toInstance(EmitterPoolComponent)
    .inTransientScope();

  container
    .bind(CLICKER_GAME_TOKENS.clickerGameBackgroundGalaxyStarsComponent)
    .toInstance(BackgroundGalaxyStarsComponent)
    .inTransientScope();

  container
    .bind(CLICKER_GAME_TOKENS.clickerGameBackgroundInteractivityComponent)
    .toInstance(BackgroundGalaxyInteractivityComponent)
    .inTransientScope();

  container
    .bind(CLICKER_GAME_TOKENS.clickerGameBackgroundGalaxyViewComponent)
    .toInstance(BackgroundGalaxyViewComponent)
    .inTransientScope();

  container
    .bind(CLICKER_GAME_TOKENS.clickerGameBonusDestroyEffectEmitterComponent)
    .toInstance(BonusDestroyEffectEmitterComponent)
    .inTransientScope();

  container.bind(CLICKER_GAME_TOKENS.clickerGameBonusDestroyEffect).toFactory(BonusDestroyEffect);

  container.bind(CLICKER_GAME_TOKENS.clickerGameStartUpScript).toInstance(StartUpScript).inTransientScope();
  container
    .bind(CLICKER_GAME_TOKENS.clickerGameResultsStartUpScript)
    .toInstance(ResultsStartUpScript)
    .inTransientScope();

  container.bind(CLICKER_GAME_TOKENS.clickerGameSpawnBonusesScript).toInstance(SpawnBonusesScript).inTransientScope();
  container.bind(CLICKER_GAME_TOKENS.clickerGameOnboardingScript).toInstance(OnboardingScript).inTransientScope();
  container
    .bind(CLICKER_GAME_TOKENS.clickerGameVisibilityChangeScript)
    .toInstance(VisibilityChangeScript)
    .inTransientScope();

  injected(BonusesObserverScript, GCS_TOKENS.gcsEngine);
  container
    .bind(CLICKER_GAME_TOKENS.clickerGameBonusesObserverScript)
    .toInstance(BonusesObserverScript)
    .inTransientScope();

  container.bind(CLICKER_GAME_TOKENS.clickerCometa).toFactory(Cometa);

  container.bind(CLICKER_GAME_TOKENS.clickerCometaViewComponent).toInstance(CometaViewComponent).inTransientScope();

  container.bind(CLICKER_GAME_TOKENS.clickerCometaDataComponent).toInstance(CometaDataComponent).inTransientScope();

  container.bind(CLICKER_GAME_TOKENS.clickerAsteroid).toFactory(Asteroid);
  container.bind(CLICKER_GAME_TOKENS.clickerAsteroidViewComponent).toInstance(AsteroidViewComponent).inTransientScope();
  container.bind(CLICKER_GAME_TOKENS.clickerAsteroidDataComponent).toInstance(AsteroidDataComponent).inTransientScope();
  container
    .bind(CLICKER_GAME_TOKENS.clickerAsteroidInteractiveComponent)
    .toInstance(AsteroidInteractiveComponent)
    .inTransientScope();

  container
    .bind(CLICKER_GAME_TOKENS.clickerCometaInteractiveComponent)
    .toInstance(CometaInteractiveComponent)
    .inTransientScope();

  container.bind(CLICKER_GAME_TOKENS.clickerGamePointsEmitter).toFactory(PointsEmitter);

  injected(PointsEmitterPoolComponent, GCS_TOKENS.gcsEngine);
  container
    .bind(CLICKER_GAME_TOKENS.clickerGamePointsEmitterPoolComponent)
    .toInstance(PointsEmitterPoolComponent)
    .inTransientScope();

  container.bind(CLICKER_GAME_TOKENS.clickerGameEmittersContainer).toFactory(EmittersContainer);
  container
    .bind(CLICKER_GAME_TOKENS.clickerGameEmittersContainerViewComponent)
    .toInstance(EmittersContainerViewComponent)
    .inTransientScope();

  container.bind(CLICKER_GAME_TOKENS.clickerGameAudioPlayer).toInstance(ClickerAudioPlayer).inSingletonScope();
  container.bind(CLICKER_GAME_TOKENS.clickerGameEvents).toInstance(ClickerGameEvents).inSingletonScope();
}
